








































































































import { Component, Vue } from 'vue-property-decorator';
import { firebaseFunctions, firebaseApp } from '@/firebase';
import DatePicker from 'vuejs-datepicker/src/components/Datepicker.vue';
import moment from 'moment-timezone';
import constants from '@/utils/constants';
import WaitingItem from './WaitingItem.vue';
import WaitingMessage from './WaitingMessage.vue';

const OPS = 'Merchant OPS';

@Component({
  components: {
    DatePicker,
    WaitingItem,
    WaitingMessage
  }
})
export default class WaitingList extends Vue {
  isLoading = false;
  now = new Date();
  initItems = {
    date: moment().format('YYYY-MM-DD'),
    selectedOutlet: {
      code: '',
      name: ''
    }
  };
  items = {
    ...this.initItems
  };
  disabledDates = {
    to: new Date(
      this.currentDate.year - 3,
      this.currentDate.month,
      this.currentDate.day
    ),
    from: new Date(
      this.currentDate.year,
      this.currentDate.month,
      this.currentDate.day + 1
    )
  };
  openSelectedOutlet = false;
  outletFilterText: string = '';
  userType: string = '';
  outletCodesFromAuth: [] = [];
  $swal: any;
  mounted() {
    this.isLoading = true;
    firebaseFunctions
      .httpsCallable('refreshAuthUser')({
        loginId: firebaseApp.auth().currentUser!.uid
      })
      .then(res => {
        const { OutletCodes, Type } = res.data.data;
        this.userType = Type;
        let outletCodes = Type === OPS ? OutletCodes.join(',') : '';
        this.outletCodesFromAuth = OutletCodes;
        if (!outletCodes && Type === OPS) return;
        this.$store.dispatch('GetWaitingStores', { outletCodes }).then((res) => {
          if (res.invalidMessage === constants.UPPER_SUCCESS && res.data.length) {
            this.items.selectedOutlet = {
              code: res.data[0].outletCode,
              name: res.data[0].name
            }
            this.list().then(() => {
              this.isLoading = false;
            });
          }
        });
      });
  }

  get getOutletCodes() {
    return this.$store.getters.GetWaitingStores.map(item => ({
      value: {
        code: item.outletCode,
        name: item.name
      },
      text: `${item.outletCode} - ${item.name}`
    }));
  }

  get filteredOutletCodes() {
    if (!this.outletFilterText) return this.getOutletCodes;
    const search = this.outletFilterText.toLowerCase();
    return this.getOutletCodes.filter((o: any) =>
      o.text.toLowerCase().includes(search)
    );
  }

  get getDisplayOutlet() {
    if (this.items.selectedOutlet.code) {
      return `${this.items.selectedOutlet.code} - ${this.items.selectedOutlet.name}`;
    }
    return '';
  }

  get getNewWaitingId() {
    return this.$store.getters.GetWaitingId;
  }

  get isFetchingOutletCodes() {
    return this.$store.getters.GetWaitingStoresFetching;
  }

  get getData() {
    return this.$store.getters.GetWaitingList;
  }

  get isFetchingData() {
    return this.$store.getters.GetWaitingFetching;
  }

  get isUpdatingData() {
    return this.$store.getters.GetWaitingUpdating;
  }

  get currentDate() {
    const now = new Date();
    return {
      year: now.getFullYear(),
      month: now.getMonth(),
      day: now.getDate()
    };
  }

  requestNewWaiting() {
    this.items.date = moment().format('YYYY-MM-DD');
    this.list();
  }

  resetAll() {
    this.items = { ...this.initItems };
  }

  async list() {
    const outletCode = this.items.selectedOutlet.code;
    const payload = {
      day: moment(this.items.date).format('YYYY-MM-DD'),
      outletCode
    };
    if (!outletCode) {
      return this.$swal(
        constants.SOMETHING_WROING,
        `Please select outlet`,
        constants.STATUS_ERROR
      );
    }
    this.$store.dispatch(
      'GetWaitingListRequest',
      payload
    );
  }

  handleUpdate(id, status) {
    let title = '';
    let text = '';
    if (status === 1) {
      title = 'NOTIFY GUEST?';
      text = 'You want to notify guest?\nClick "OK" to send'
    } else if (status === 2) {
      title = 'SEAT GUEST?';
      text = 'You want to seat guest?\nClick "OK" to confirm'
    } else if (status === 3) {
      title = 'CANCEL GUEST?';
      text = 'You want to cancel guest?\nClick "OK" to confirm'
    }
    this.$swal({
      title,
      text,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true,
    }).then((ok) => {
      if (ok) {
        this.update(id, status);
      }
    })
  }

  async update(id, status) {
    const payload = {
      id,
      status
    };
    const result = await this.$store.dispatch(
      'UpdateWaitingRequest',
      payload
    );
    if (result.invalidMessage !== constants.UPPER_SUCCESS) {
      return this.$swal(
        constants.SOMETHING_WROING,
        result.invalidMessage,
        constants.STATUS_ERROR
      );
    } else {
      this.list();
      return this.$swal(
        constants.SUCCESS_MESSAGE,
        '',
        constants.STATUS_SUCCESS
      );
    }
  }

  toggleSelectedOutlet() {
    this.openSelectedOutlet = !this.openSelectedOutlet;
  }

  onChangeOutletCode(event) {
    this.items.selectedOutlet = {
      code: event.code,
      name: event.name
    }
    this.$store.commit('SET_WAITING_ID', null);
    this.toggleSelectedOutlet();
    this.list();
  }
}
